import angular, { IPromise } from "angular";
import { IAppRootScopeService } from "@app/app.definition";
import { JavaApiAdapterService } from "@common/apiadapter/javaapi.service";
import { FormService } from "@common/service/form.service";
import { CacheService } from "@common/service/cache.service";
import { PopUpService } from "@common/popup/popup.service";
import { UtilityService } from "@common/service/util.service";
import { SnackbarService } from "@common/service/snackbar.service";
import { DocumentFolderService } from "@common/itemBoard/components/itemFolder/services/documentFolder.service";
import { BroadcastService } from "@common/service/broadcast.service";
import { CommonService } from "@common/common.service";
import { Util } from "@common/util";
import { Form, WorkflowActions } from "@common/model/form";
import { FIELD_TYPE } from "@common/schemaFormUtility/components/formsUtility/formsUtility";
import { User } from "@common/model/user";
import { Subject } from "@common/model/subject";
import _ from "lodash";
import {IServiceManager} from "@common/service/serviceManager";

export interface IEcvForm {
    formId: number;
    ref: string;
    form: any;
    schema: any;
    model: any;
    formData: any;
    viewOnly: boolean;
    resp: any;
    formTitle: string;
    formDescription: string;
    formLoaded: boolean;
    assignmentId: number;
    formLoadingError: boolean;
    submitDisabled: boolean;
    submitTooltip: string;
    onLoadCallback: Function;
    unloadFunction: any;
    rootScope: any;

    init(): void;

    isModelChanged(): boolean;

    isUploadInProgress(): boolean;

    setUnloadFunction(f: any): void;

    setDeRegisterStateChange(f: any): void;

    logout(): void;

    signatureRequired: boolean;
    isSigned: boolean;
    signature: any;
    $validationProvider: any;
    formLogo: string;
    formSubmitAvailableInfo: string;
    formSubmitUnavailableInfo: string;
    formAlreadySubmitted: boolean;
    breadcrumb: string;
    service;
    selectedSubject;
}

export class EcvForm implements IEcvForm {
    formId: number;
    ref: string;
    form: any;
    schema: any;
    model: any;
    formData: any;
    viewOnly: boolean;
    resp: any;
    formTitle: string;
    formDescription: string;
    formLoaded: boolean;
    assignmentId: number;
    formLoadingError: boolean;
    submitDisabled: boolean;
    submitTooltip: string;
    onLoadCallback: Function;
    unloadFunction: any;
    deRegisterStateChange: any;
    rootScope: any;
    signatureRequired: boolean;
    isSigned: boolean;
    signature: any;
    $validationProvider: any;
    formLogo: string;
    digitalSigned: any
    formSubmitAvailableInfo: string = "";
    formSubmitUnavailableInfo: string = "";
    autofilled: number[] = [];
    formAlreadySubmitted: boolean;
    breadcrumb: string;
    reportEnabled: boolean;
    subjectId: number;
    hasFormOptions: boolean = false;
    formUtils;
    skipFields: any = [];
    embeddedForm;
    formModel;
    sbmtSuccess;
    isActiveAssignor: boolean = false;
    isCrntUserSameOrgActiveAssignee: boolean = false;
    service;
    showEdit: boolean;
    showPendingMigration: boolean = false;
    showBeginDetermination: boolean = false;
    showAssignService: boolean = false;
    workflowActionEnum: any;
    formSubj;
    crntUser;
    services: any;
    frmSaved: boolean = false;
    fldCounter;
    reqFlds;
    fieldConfigurationsData;
    tpUpd;
    timePckrFlds = [];
    formRoles;
    formUsers;
    canUserSubmit = true;
    signFlds = [];
    selectedSubject: any;
    isEditAction = false;
    signConsent: string;
    noteSaveCallback: Function;

    static $inject = ["$state", "$scope", "$q", "$rootScope", "ApiAdapterService", "FormService", "CacheService",
        "PopUpService", "UtilityService", "$injector", "$uibModal",
        "SnackbarService", "$timeout", "$interval", "CommonService", "DocumentFolderService", "BroadcastService","ServiceManager", "FormsUtilityFactory"];

    constructor(
        private $state: angular.ui.IStateService,
        private $scope: angular.IScope,
        private $q: angular.IQService,
        private $rootScope: IAppRootScopeService,
        private ApiAdapterService: JavaApiAdapterService,
        private FormService: FormService,
        private CacheService: CacheService,
        private PopUpService: PopUpService,
        private UtilityService: UtilityService,
        private $injector: angular.auto.IInjectorService,
        private $uibModal: angular.ui.bootstrap.IModalService,
        private $_snack: SnackbarService,
        private $timeout: angular.ITimeoutService,
        private $interval: angular.IIntervalService,
        private $_com: CommonService,
        private DocumentFolderService: DocumentFolderService,
        private BroadcastService: BroadcastService,
        private $_serviceManager: IServiceManager,
        private FormsUtilityFactory
    ) {
        let context = this;
        let print = $rootScope.print;
        window.print = function () {
            $('#printContainer').children().remove();
            UtilityService.printLayout('portrait');
            print();
        };
        this.$validationProvider = $injector.get('$validation');
        this.formLoaded = false;
        this.formLoadingError = false;
        this.resp = {};
        this.submitDisabled = true;
        this.isSigned = false;
        this.rootScope = this.$rootScope;
        this.rootScope.mainShowLoader = false;
        this.signature = {
            consent: false,
            signedBy: ''
        };
        this.digitalSigned = true;
        this.formAlreadySubmitted = false;
        this.formSubmitAvailableInfo = Util.FORM_SUBMIT_AVAILABLE_INFO;
        this.formSubmitUnavailableInfo = Util.FORM_SUBMIT_UNAVAILABLE_INFO;
        this.workflowActionEnum = WorkflowActions;
        this.rootScope.isFormChanged = () => this.isModelChanged();
        $scope.$on("$destroy", function () {
            window.print = print;
            BroadcastService.removeCallBack('reload-form', $scope.$id);
            $("#theForm").off('focusin', context.focusFunc)
            $(".mainBody, .service-note-container").off('click', context.focusFunc);
            $("#theForm").off('keydown', context.keydnFunc as any);
            (context.timePckrFlds.length > 0 && !!context.tpUpd) && (context.tpUpd());
        });
    }

    //This function adds a bckgd color to the focused fields
    focusFunc = (event) => {
        $('.form-group').removeClass('focus-bkgd');
        let dv = $(event.target).closest('.form-group');
        if (!$(dv).hasClass('div-disabled') && !$(dv).hasClass('schema-form-label')) {
            dv.addClass('focus-bkgd');
        }
    }

    frmLoadFunc = () => {
        let field = $("#theForm").find('.field-1');
        let fld = 1;
        while (!!field && !!field.length && field.attr('class').includes('div-disabled')) {
            fld++;
            field = $('#theForm').find('.field-' + fld);
        }
        if (!!field && !!field.length) {
            let ncl = field.attr('class');
            if (ncl.includes('schema-form-uibselect') || ncl.includes('schema-form-dynamicList')) {
                $(field.find('.ui-select-toggle')).click();
            } else {
                if (ncl.includes('schema-form-timePicker')) {
                    let sl = field.find('md-select');
                    sl.length > 0 && ($(sl[0]).focus());
                } else {
                    $(field.find('input,textarea,button,a')[0]).focus();
                }
            }
        }
    }

    //This function opens the dropdown on single hit when user tabs through the fields
    keydnFunc = (event: KeyboardEvent) => {
        if (event.key == 'Tab') {
            let field = $(event.target).closest('.form-group');
            let cl = field.attr('class');
            let ind = cl.indexOf("field-");
            let fld: number = parseInt(cl.slice(ind + 6, cl.indexOf(" ", ind)), 10);
            let nfield;
            if (
                cl.includes('schema-form-uidatepicker') &&
                !!($(event.target).scope() as any).dtpVm &&
                !!($(event.target).scope() as any).dtpVm.isOpen
            ) {
                ($(event.target).scope() as any).dtpVm.isOpen = false;
            }
            if (event.shiftKey) {
                do {
                    fld--;
                    nfield = $('#theForm').find('.field-' + fld);
                } while ((!nfield.length || nfield.attr('class').includes('div-disabled')) && fld >= 0)
            } else {
                do {
                    fld++;
                    nfield = $('#theForm').find('.field-' + fld);
                } while ((!nfield.length || nfield.attr('class').includes('div-disabled')) && fld <= this.fldCounter)
            }
            if (!!nfield.length) {
                let ncl = nfield.attr('class');
                if ((ncl.includes('schema-form-uibselect') || ncl.includes('schema-form-dynamicList')) && (!cl.includes('schema-form-timePicker') || $(event.target).context.nodeName == 'MD-SELECT') && (!cl.includes('schema-form-uidatepicker') || $(event.target).attr('class').includes('date-btn'))) {
                    $(nfield.find('.ui-select-toggle')).click();
                } else if (cl.includes('schema-form-uibselect') || cl.includes('schema-form-dynamicList')) {
                    if (event.shiftKey && ncl.includes('schema-form-timePicker')) {
                        let sl = nfield.find('md-select');
                        sl.length > 0 && ($(sl[0]).focus());
                    } else {
                        $(nfield.find('input,textarea,button,a')[0]).focus();
                    }
                    event.preventDefault();
                }
            }
        }
    }

    init = (): void => {
        this.sbmtSuccess = false;
        this.formLoaded = false;
        this.formLoadingError = false;
        this.rootScope.mainShowLoader = true;
        this.submitTooltip = Util.FORM_SUBMIT_TOOLTIP;
        this.signConsent = Util.FORM_SIGN_CONSENT;
        this.digitalSigned = true;
        this.formUtils = this.FormsUtilityFactory.create('theForm', this.$scope);

        let pg;
        switch (this.ref) {
            case 'asfr':
            case 'asf':
            case 'dshbd-asf':
                this.breadcrumb = 'Assigned Forms';
                pg = 'assignedForms';
                break;
            case 'cmpfr':
            case 'cmpf':
            case 'dshbd-cmpf':
                this.breadcrumb = 'Submitted Forms';
                pg = 'completedForms';
                break;
            case 'avfr':
            case 'avf':
            default:
                this.breadcrumb = 'Available Forms';
                pg = 'availableForms';
                break;
        }

        if (!!this.embeddedForm) {
            this.formModel = window['fmodel'];
            if (typeof (this.formModel) == 'object') {
                this.formId = this.formModel.id;
                this.renderForm(this.formModel);
            } else {
                this.formLoadingError = true;
                this.rootScope.mainShowLoader = false;
            }
        } else if (this.ref == 'avfr' || this.ref == 'asfr') {
            this.ApiAdapterService.getFormTemplate(this.formId).then(s => {
                this.renderForm(s);
            }, e => {
                this.rootScope.mainShowLoader = false;
                this.formLoaded = true;
                this.formLoadingError = true;
                console.log(e);
            });
        } else {
            let password = this.CacheService.getPassword();
            const currentSubj = this.CacheService.getCurrentSubject();
            this.ApiAdapterService.getAssignedForm(this.assignmentId, password).then(s => {
                if (s && currentSubj && s.subjectId !== currentSubj.subjectId && s.subjectId !== 0) {
                    this.FormService.manageForms(pg);
                    this.rootScope.activeResourceSubjectId = null;
                    return;
                }
                this.rootScope.activeResourceSubjectId = s.subjectId;
                this.reportEnabled = s.reportEnabled;
                if (!!s.subjectId) {
                    this.ApiAdapterService.getSubject(s.subjectId, this.CacheService.getPassword(), true).then(sub => {
                        this.formSubj = sub;
                        this.renderForm(s);
                    });
                } else {
                    this.renderForm(s);
                }
            }, e => {
                this.rootScope.mainShowLoader = false;
                this.formLoaded = true;
                this.formLoadingError = true;
                console.log(e);
            });
        }

        this.BroadcastService.registerCallBack('reload-form', this.$scope.$id, (isEdit = false) => {
            this.isEditAction = isEdit;
            this.init();
        })
    }

    fieldStringReplace(original, user, subject): string {
        // in case of '$' character in string the replace does not work as expected, so here the change like .replace(/\$/g, "$$$$") added
        // for more details refer https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replace#Specifying_a_string_as_a_parameter
        if (!!subject.firstName) original = original.replace('${SUBJECT_FIRST}', subject.firstName.replace(/\$/g, "$$$$"))
        if (!!subject.fullName) original = original.replace('${SUBJECT_FULL}', subject.fullName.replace(/\$/g, "$$$$"))
        if (!!user.firstName) original = original.replace('${USER_FIRST}', user.firstName.replace(/\$/g, "$$$$"));
        return original
    }

    fixTitles = (section, user: User, subject: Subject) => {
        !!section.title && (section.title = this.fieldStringReplace(section.title, user, subject));

        if (!!section.sections) {
            for (let innerSection of section.sections) {
                this.fixTitles(innerSection, user, subject);
            }
        } else if (!!section.items) {
            for (let field of section.items || []) {
                !!field.title && (field.title = this.fieldStringReplace(field.title, user, subject));
                !!field.labelText && (field.labelText = this.fieldStringReplace(field.labelText, user, subject));
                !!field.placeholder && (field.placeholder = this.fieldStringReplace(field.placeholder, user, subject));
                this.fixTitles(field, user, subject);
            }
        }
    }

    fixFormTitles = (form): void => {
        if (!!this.formSubj) {
            let user = this.CacheService.getUser();
            for (let section of (form.sections || form)) {
                this.fixTitles(section, user, this.formSubj);
            }
        }
    }

    checkStatus = () => {
        if (_.includes([Util.FORM_STATUS.COMPLETED, Util.FORM_STATUS.SUBMITTED], this.resp.status)) {
            if ((this.ref == 'asf' || this.ref == 'dshbd-asf') && (!!this.resp.dateSubmitted || this.resp.status == Util.FORM_STATUS.SUBMITTED)) {
                this.formAlreadySubmitted = true;
                this.PopUpService.openInformationModal(Util.FORM_ALREADY_SUBMITTED_RELOAD_MSG, null, null, null, true).then(
                    () => {
                        if (this.ref == 'dshbd-asf') {
                            this.$state.go('parent-dashboard', { team: this.$state.params.subjectId });
                        } else {
                            this.FormService.manageForms('assignedForms');
                        }
                    }
                );
            } else {
                this.submitDisabled = false;
            }
        } else {
            this.submitDisabled = true;
        }
    }


    renderForm = (s: any): void => {
        this.crntUser = !this.embeddedForm ? this.CacheService.currentUser : null;
        if (!!this.crntUser && !this.crntUser.organizationId) {
            let userExperience = this.CacheService.getUserExperience();
            this.crntUser.organizationId = Util.safeAccess(userExperience, ['sponsor', 'orgId']);
        }
        this.autofilled = [];
        this.resp = s;
        this.resp = new Form().deserialize(this.resp);
        this.formTitle = this.resp.title;
        this.formDescription = this.resp.description;
        this.formRoles = this.resp.roles;
        this.formUsers = this.resp.formUsers;
        this.model = {};
        this.signatureRequired = this.resp.signatureRequired;
        this.formLogo = this.resp.logo;
        this.isCrntUserSameOrgActiveAssignee = !!this.resp.assignees && (!!this.resp.assignees.filter(f => f.user.isActive && !f.user.isFormerTeamMember && f.userId == this.crntUser.id && this.resp.orgId == this.crntUser.organizationId).length);
        this.showEdit = this.DocumentFolderService.isActionAllowed(this.resp.workflowAction, WorkflowActions.EDIT_AFTER_SUBMIT);
        this.showPendingMigration = this.DocumentFolderService.isActionAllowed(this.resp.workflowAction, WorkflowActions.PENDING_MIGRATION);
        this.showBeginDetermination = this.DocumentFolderService.isActionAllowed(this.resp.workflowAction, WorkflowActions.BEGIN_DETERMINATION);
        this.showAssignService = this.DocumentFolderService.isActionAllowed(this.resp.workflowAction, WorkflowActions.ASSIGN_SERVICE);
        this.services = this.resp.services;
        //Form options should be available only if the assignor is filling up the form
        if (!!this.crntUser && this.crntUser.userId == this.resp.assignorId) {
            this.hasFormOptions = true;
            if (!!this.resp.assignor && !this.resp.assignor.isFormerTeamMember && !!this.formSubj && !this.formSubj.isFrozen) {
                this.isActiveAssignor = true;
            }
        }
        if (this.showPendingMigration) {
            if (!this.showEdit || !this.isActiveAssignor) {
                this.showEdit = false;
            }
        } else {
            if (!this.showEdit || !this.isCrntUserSameOrgActiveAssignee) {
                this.showEdit = false;
            }
        }

        if (!!this.onLoadCallback) {
            this.onLoadCallback(this.formTitle);
        }
        if (!!this.signatureRequired) {
            this.submitTooltip = Util.FORM_SIGN_SUBMIT_TOOLTIP;
        }
        this.checkStatus();
        this.canUserSubmit = this.FormService.checkSubmitterRole(this.formUsers, this.formRoles);
        if (!!this.resp.formSignature) {
            this.isSigned = true;
        }
        let parsedForm;
        let postParse = () => {
            this.fixFormTitles(parsedForm.form);
            this.form = parsedForm.form;
            this.schema = parsedForm.schema;
            this.model = parsedForm.model;
            this.signature = parsedForm.signature;
            this.fieldConfigurationsData = angular.copy(parsedForm.fieldConfigurationsData);
            this.reqFlds = parsedForm.reqFlds;
            this.fldCounter = parsedForm.fldCounter;
            this.timePckrFlds = parsedForm.timePckrFlds;
            this.signFlds = parsedForm.signFlds;
            this.skipFields = parsedForm.skipFields;
            this.autofilled = parsedForm.autofilled;
        };

        let setIntervalToCheckDynamicFieldStatus = () => {
            const promise = this.$interval(
                () => {
                    if (this.formUtils.penddingDynUiSelect() == 0) {
                        this.$interval.cancel(promise);
                        this.rootScope.mainShowLoader = false;
                    }
                }, 1000);
        }
        this.fetchCstmAttr(this.resp).then(() => {
            this.resp.readOnly = this.viewOnly;
            parsedForm = this.formUtils.parseForm(angular.copy(this.resp), null, this.formSubj, this.embeddedForm, this.selectedSubject, this.service, this.frmSaved, this.viewOnly);
            postParse();
            this.$timeout(() => {
                $("html, body").animate({
                    scrollTop: 0
                }, 0);

                this.frmLoadFunc();

                $("#theForm").off('focusin', this.focusFunc).on('focusin', this.focusFunc);
                $(".mainBody, .service-note-container").off('click', this.focusFunc).on('click', this.focusFunc);
                $("#theForm").off('keydown', this.keydnFunc as any).on('keydown', this.keydnFunc as any);

                //To remove the required field errors from time picker
                if (this.timePckrFlds.length > 0) {
                    this.tpUpd = this.rootScope.$on('mdpTimePickerUpdated', (event, data) => {
                        this.timePckrFlds.forEach(tp => {
                            let t = tp.key[0];
                            let dv = $('.parent-div-' + t);
                            this.model[t] = this.UtilityService.resetTimePicker(t, this.model[t]);
                            !!tp.onChangeAction && (tp.onChange(this.model[t], tp));
                            if (this.UtilityService.checkTimePickerMdl(t, this.model[t])) {
                                dv.removeClass('req-fld-div');
                                if ($('#parent-' + t).hasClass('has-error')) {
                                    this.$scope.$broadcast('schemaForm.error.' + t, 'tv4-302', true);
                                }
                            } else {
                                (_.includes(this.reqFlds, t) && !dv.hasClass('no-edit-role') && this.frmSaved && !dv.hasClass('req-fld-div')) && (dv.addClass('req-fld-div'));
                            }
                        });
                    });
                }
            }, 500);
        }, () => {
            console.log('error while auto fill fields..');
        }).finally(() => {
            this.formLoaded = true;
            setIntervalToCheckDynamicFieldStatus();
        });
    }

    fetchCstmAttr = (formResponse: any) => {
        let deferred = this.$q.defer();
        if (!this.viewOnly) {
            if (!!this.formSubj && this.formSubj.teamType == 'student' && !this.formSubj.customAttributes) {
                this.ApiAdapterService.getSubject(formResponse.subjectId, this.CacheService.getPassword(), true).then((sub) => {
                    this.formSubj.customAttributes = sub.customAttributes;
                    this.formSubj.teams = sub.teams;
                    deferred.resolve();
                });
            } else {
                deferred.resolve();
            }
        } else {
            deferred.resolve();
        }

        return deferred.promise;
    }

    editDefaultTrails = (resultConfig) => {
        for (let config of this.fieldConfigurationsData) {
            if (config.option == "Trial Count") {
                config.field.fieldOptions.defaultRows = resultConfig.field.fieldOptions.defaultRows;
                let fld = this.formUtils.fetchField(this.form, config.field.id);
                fld.maxRows = config.field.fieldOptions.defaultRows;
            }
        }

    }

    updateTrialsCall = (assignmentId, fieldId, trialCount, frm) => {
        this.ApiAdapterService.updateTrialCount({
            "assignmentId": assignmentId,
            "fieldId": fieldId,
            "trialCount": trialCount
        }).then(() => {
            this.saveForm(frm, true).finally(() => {
                this.rootScope.mainShowLoader = false;
            });
        },
            (e) => {
                this.PopUpService.openInformationModal(e);
            });
    }

    editFieldConfiguration = (frm): any => {
        let deferred = this.$q.defer();
        let defaultRowCountBackup;
        for (let config of this.fieldConfigurationsData) {
            if (config.option == "Trial Count") {
                defaultRowCountBackup = config.field.fieldOptions.defaultRows;
            }
        }
        this.$uibModal.open({
            templateUrl: 'app/common/popup/fieldConfigurationsPopup/fieldConfigurationsPopup.html',
            controller: 'FieldConfigurationsPopupController',
            controllerAs: 'fieldConfigurationsPopupVm',
            windowClass: 'field-configurations-modal',
            backdrop: 'static',
            resolve: {
                assignmentId: () => this.assignmentId,
                fieldConfigurationsData: () => this.fieldConfigurationsData,
                dataModel: () => this.model
            }
        }).result.then(
            (s) => {
                if (!!s) {
                    this.$validationProvider.validate(frm).then(() => {
                        this.rootScope.mainShowLoader = true;
                        this.updateTrialsCall(s.assignmentId, s.config.field.id, s.trialCount, frm);
                        this.model = s.dataModel;
                        this.editDefaultTrails(s.config);
                        deferred.resolve(s);
                    }, (e) => {
                        this.rootScope.mainShowLoader = false;
                        for (let config of this.fieldConfigurationsData) {
                            if (config.option == "Trial Count") {
                                config.field.fieldOptions.defaultRows = defaultRowCountBackup;
                            }
                        }
                        this.PopUpService.openInformationModal("Please correct any errors in the form before updating the form options.");
                        console.log(e);
                    });
                }
            },
            (e) => {
                deferred.reject(e);
                console.log(e);
            });
        return deferred.promise;
    }

    generateResponse = (frm, modelCpy) => {
        let answers = [], formDocs = {}, totalDocs = 0;
        let context = this, deleteRespArr = ["$$DELETE$$", "$$FORCE_DELETE$$"];

        let processModel = (fldSchema, fld, model, p, index?) => {
            let autofill: boolean = !!this.autofilled.find(n => n == fldSchema.id);
            if (fldSchema['valueType'] == FIELD_TYPE.DYN_UI_SELECT && !!fld && fld['inputType'] == FIELD_TYPE.MULTI_SELECT && !!fld['fldConfig']['value']) {
                if (fld['fldConfig']['value'].length > 0) {
                    model = _.map(fld['fldConfig']['value'], 'id');
                } else {
                    model = null;
                }
            }
            if (fldSchema['type'] == FIELD_TYPE.PHONE_NUMBER) {
                let ph = p + '-' + FIELD_TYPE.PHONE;
                let mdl = modelCpy[ph];
                let extn = modelCpy[p + '-' + FIELD_TYPE.EXT];
                if (!!extn && ((!this.showEdit && !this.embeddedForm) || !!mdl || !_.includes(this.reqFlds, ph))) {
                    mdl += ' Ext.' + extn;
                }
                model = mdl;
            }
            let oldProp = autofill ? null : this.formUtils.modelBak[p];

            if (fldSchema['valueType'] == FIELD_TYPE.COMPOSITE_LIST) {
                if (!!model) {
                    _.remove(this.model[p], m => Object.keys(m).length == 0);
                    _.remove(model, m => Object.keys(m).length == 0);
                    model = model.map((item, index) => {
                        if (Object.keys(item).length > 0) {
                            item['index'] = index + 1;
                            if ('isPanelOpen' in item) {
                                delete item['isPanelOpen'];
                            }
                            if ('headerText' in item) {
                                delete item['headerText'];
                            }
                        }
                        return item;
                    });
                }
                if (!!oldProp) {
                    oldProp = oldProp.map((item, index) => {
                        item['index'] = index + 1;
                        if ('isPanelOpen' in item) {
                            delete item['isPanelOpen'];
                        }
                        if ('headerText' in item) {
                            delete item['headerText'];
                        }
                        return item;
                    });
                }
            }

            //This is for the scenario when user clears a required field and
            // signatures assigned to other roles get reset
            if (oldProp && model == "$$FORCE_DELETE$$") {
                _.remove(this.skipFields, (f) => {
                    return f == fldSchema['id'];
                });
            }
            //////////////////
            if ((_.includes([FIELD_TYPE.PHONE, FIELD_TYPE.EXT, FIELD_TYPE.HYPERLINK], fldSchema['valueType'])) ||
                (fldSchema['valueType'] == FIELD_TYPE.SIGNATURE && !!oldProp && !!oldProp['signature'] && !!model && !!model['signature']) ||
                (!autofill && !fldSchema['id']) ||
                (fldSchema['valueType'] != 'fileUpload' && !this.isEditAction && _.isEqual(oldProp, model)) ||
                ((fldSchema['type'] == 'date' || fldSchema['type'] == 'time') && !this.isEditAction && !autofill && oldProp + "" == model + "") ||
                !!this.skipFields.includes(fldSchema['id']) || (fldSchema['type'] == 'array' && !oldProp && (!model || model.length == 0))) {
                return;
            }

            if (['string', 'date', 'time', 'number', 'array', 'object', FIELD_TYPE.PHONE_NUMBER].includes(fldSchema['type'])) {
                if (fldSchema['valueType'] == 'fileUpload') {
                    if (!!oldProp && oldProp['documents'].length > 0 && model['documents'].length == 0) {
                        model = "$$DELETE$$";
                    }
                } else if (!!oldProp && !model && (fldSchema['type'] != "number" || model !== 0)) {
                    model = "$$DELETE$$";
                }
            } else if (!this.isEditAction && !model) {
                return;
            }

            let ans = model;

            if (fldSchema['valueType'] == 'date' && ans != null && !_.includes(deleteRespArr, ans)) {
                ans = Util.getUTCTime(new Date(ans));
            } else if (fldSchema['valueType'] == 'table' && model && model.length > 0) {
                if (!autofill && JSON.stringify(oldProp) == JSON.stringify(model)) {
                    return;
                }
                let mod = angular.copy(model);
                for (let item in mod) {
                    for (let attr in mod[item]) {
                        if (fldSchema.valueType == "table") {
                            if (!!fldSchema.items.properties[attr] &&
                                fldSchema.items.properties[attr].type == "date") {
                                if (!!mod[item][attr]) {
                                    model[item][attr] = Util.getUTCTime(new Date(mod[item][attr]));
                                }
                            }
                        }
                    }
                }
                ans = JSON.stringify(model);
            } else if (fldSchema['valueType'] == FIELD_TYPE.COMPOSITE_LIST) {
                let items = fldSchema['items']['properties'];
                if (!!model && !_.includes(deleteRespArr, ans)) {
                    model.forEach((ans, index) => {
                        Object.keys(items).forEach(k => {
                            let key = k.split(FIELD_TYPE.FILE_UPLOAD).slice(-1)[0];
                            if (ans[k] != null && ans[k] != undefined) {
                                let itmFld = context.formUtils.fetchField(this.form, items[k]['id']);
                                let val = processModel(items[k], itmFld, ans[k], k, index);
                                if (typeof val !== 'string') {
                                    ans[key] = JSON.stringify(val);
                                } else {
                                    ans[key] = val;
                                }
                                if (key != k) {
                                    !!ans[k] && delete ans[k]
                                }
                            }
                        });
                    })

                    ans = JSON.stringify(model);
                } else {
                    ans = undefined;
                }
            } else if (fldSchema['valueType'] == 'fileUpload' && !_.includes(deleteRespArr, ans)) {
                if (!!model) {
                    let fldSchemaId = _.replace(fldSchema['id'], new RegExp('field', 'g'), "");
                    fldSchemaId = _.replace(fldSchemaId, FIELD_TYPE.FILE_UPLOAD, "");
                    let keyArr = fldSchemaId.split('.');
                    let fId = keyArr.slice(-1)[0];
                    let prnt = _.replace(keyArr[0], `[]`, `[${index}]`)
                    if (!!model['documents']) {
                        let documents = model['documents'].filter(f => !!f['photoFile']);
                        if (documents.length > 0) {
                            totalDocs += documents.length;
                            !_.has(formDocs, prnt) && _.set(formDocs, prnt, {});
                            if (keyArr.length > 1) {
                                _.set(formDocs, `${prnt}.${fId}`, documents);
                            } else {
                                _.set(formDocs, fId, documents);
                            }
                        }
                    }
                    if (!!model['filenames']) {
                        let files = [];
                        //If doc title and foldername are displayed on the file upload field,
                        // then need to send the same to the backend so that it is displayed when the form is opened again.
                        if (Util.safeAccess(fld, ['showDocDetails', 'foldersDrpdwn'])) {
                            for (let i = 0; i < model['filenames'].length; i++) {
                                let t = model['filenames'][i];
                                let d = model['documents'][i];
                                let docAns = { "fileName": t.fullFilename, "title": d.title, "folderName": d.folderName };
                                if (t.documentId) {
                                    docAns['documentId'] = t.documentId;
                                }
                                files.push(docAns);
                            }
                        } else { // else if doc title and foldername are not needed.
                            files = model['filenames'].map((t) => {
                                if (!t.documentId) {
                                    return t.fullFilename;
                                } else {
                                    return { "documentId": t.documentId, "fileName": t.fullFilename };
                                }
                            });
                        }

                        ans = files.length > 0 ? JSON.stringify(files) : null;
                    }
                }
            } else if (fldSchema['valueType'] == FIELD_TYPE.COMPOSITE && !_.includes(deleteRespArr, ans)) {
                let items = fldSchema['items']['properties'];
                if (!!model && Object.keys(model).length > 0) {
                    Object.keys(items).forEach(k => {
                        let key = k.split(FIELD_TYPE.FILE_UPLOAD).slice(-1)[0];
                        if (model[k] != null && model[k] != undefined) {
                            let itmFld = context.formUtils.fetchField(this.form, items[k]['id']);
                            let val = processModel(items[k], itmFld, model[k], k);
                            if (typeof val !== 'string') {
                                model[key] = JSON.stringify(val);
                            } else {
                                model[key] = val;
                            }
                            if (key != k) {
                                !!model[k] && delete model[k];
                            }
                        }
                    });
                    ans = JSON.stringify(model);
                } else {
                    ans = undefined;
                }
            } else if (fldSchema['valueType'] == FIELD_TYPE.TIME_PICKER && !_.includes(deleteRespArr, ans)) {
                ans = Util.getUTCDateTime(ans);
            } else if (fldSchema['valueType'] == FIELD_TYPE.SIGNATURE && !_.includes(deleteRespArr, ans)) {
                ans = JSON.stringify(model);
            } else if (fldSchema['valueType'] == FIELD_TYPE.SUBJECTS && !!model) {
                if (!!fld && fld['inputType'] == 'single-select') {
                    ans = model.subjectId;
                } else {
                    ans = _.map(model, 'subjectId');
                }
            }

            if ((this.isEditAction && deleteRespArr.includes(ans))
                || (fldSchema['valueType'] == FIELD_TYPE.SIGNATURE && (!model || !model['signature']))) {
                return;
            }

            if (Array.isArray(ans)) {
                ans = JSON.stringify(ans);
            }
            return ans;
        }
        let modelBakCpy = angular.copy(this.formUtils.modelBak);
        let obj = { modelCpy: modelCpy, modelBakCpy: modelBakCpy };
        for (let p in this.schema.properties) {
            let fldSchema = this.schema.properties[p];
            let fieldId = fldSchema['id'].split("field")[1];
            let fld = this.formUtils.fetchField(this.form, fldSchema['id']);
            if (!!frm[p] && !!frm[p].$dirty && !!fld && !!fld.editMode) {
                !!fld.saveField && fld.saveField();
            }
            let fldVisible = true;
            if (!!fld && !!fld.condition && !_.includes(fld.condition, 'arrayIndex') && fld.setNullIfHidden) {
                try {
                    fldVisible = Function("const model = this.modelCpy; const modelBak = this.modelBakCpy; return " + fld.condition).apply(obj);
                } catch (error) {
                    console.log('Error : ', error);
                }
            }

            if (modelCpy && fldVisible) {
                let val = processModel(fldSchema, fld, modelCpy[p], p);
                if (!!val || (fldSchema['type'] == "number" && val == 0)) {
                    answers.push({
                        id: fieldId,
                        label: fldSchema['label'],
                        answer: val
                    });
                }
            }
        }
        let res = {
            formResponse: {
                assignmentId: this.assignmentId,
                fields: answers
            },
            formDocs: formDocs,
            totalDocs: totalDocs
        };
        return res;
    }

    postSaveHandler = (status) => {
        this.resp.status = status;
        this.checkStatus();
        this.frmSaved = this.formUtils.frmSaved = true;
        this.signFlds.length > 0 && (this.formUtils.handleSignatureFlds());
        this.formUtils.handleRequiredFieldValidations(this.$timeout, 'ecv-form');
    }

    saveForm = (frm, silent?: boolean, skipHandler?: boolean): any => {
        let deferred = this.$q.defer();
        let context = this;
        let modelCpy = _.cloneDeep(this.model);

        this.$validationProvider.validate(frm)
            .success(() => {
                let resp = this.generateResponse(frm, modelCpy);
                let formResponse = resp['formResponse'];
                if (!!this.service) {
                    formResponse['noteId'] = this.formId;
                    deferred.resolve(formResponse);
                } else {
                    this.FormService.uploadFrmDocs(this.assignmentId, resp['formDocs'], resp['totalDocs']).then(() => {
                        this.rootScope.mainShowLoader = "Saving Form...";
                        let password = this.CacheService.getPassword();
                        this.ApiAdapterService.saveFormResponses(formResponse, password).then((s) => {
                            this.formUtils.modelBak = angular.copy(this.model);
                            this.autofilled = [];
                            modelCpy = undefined;
                            !skipHandler && this.postSaveHandler(s.status);
                            deferred.resolve(true);
                            if (!silent) {
                                this.rootScope.mainShowLoader = false;
                                toastr.success(Util.FORM_SAVE_SUCCESS);
                            }
                        }, (e) => {
                            modelCpy = undefined;
                            deferred.reject(e);
                            if (e.errorCode == 'FORM_ALREADY_SUBMITTED') {
                                toastr.success(Util.FORM_ALREADY_SUBMITTED_ERROR);
                            } else if (e.errorCode == 'ASSIGNED_FORM_DELETED') {
                                toastr.success(Util.ASSIGNED_FORM_DELETED);
                            } else {
                                let vldMsg = 'Please correct any errors before ' + (this.resp.status == Util.FORM_STATUS.SUBMITTED ? 'submitting' : 'saving') + ' the form.';
                                context.$_snack.showErrorToastr({ message: vldMsg });
                                this.formUtils.parseBackendErrors(e.payload, this.$scope);
                            }
                            this.rootScope.mainShowLoader = false;
                        });
                    }, (err) => {
                        this.rootScope.mainShowLoader = false;
                        toastr.success(Util.FORM_SAVE_ERROR);
                        deferred.reject(err);
                    });
                }


            })
            .error(function (message) {
                context.$_snack.showErrorToastr({ message: 'Please correct any errors before saving the form.' });
                console.log("Validation Error:", message)
                deferred.reject();
            });

        return deferred.promise;

    }

    submitForm = (theForm): IPromise<any> => {
        let deferred = this.$q.defer();
        this.saveForm(theForm, true).then(() => {
            if (this.resp.status == Util.FORM_STATUS.COMPLETED ||
                (this.resp.status == Util.FORM_STATUS.SUBMITTED && (this.ref == 'cmpf' || this.ref == 'cmpfr' || this.ref == 'dshbd-cmpf'))) {
                this.FormService.submitForm(this.assignmentId).then(() => {
                    this.rootScope.mainShowLoader = false;
                    this.deRegisterStateChange && this.deRegisterStateChange();
                    if (!!this.showPendingMigration || !!this.showAssignService) {
                        this.FormService.triggerWorkflow(this.resp, !!this.showPendingMigration ? WorkflowActions.PENDING_MIGRATION : WorkflowActions.ASSIGN_SERVICE, true).finally(() => {
                            this.cancel();
                            deferred.resolve();
                        });
                    } else {
                        toastr.success(Util.FORM_SUBMIT_SUCCESS);
                        this.cancel();
                        deferred.resolve();
                    }

                }, (e) => {
                    this.rootScope.mainShowLoader = false;
                    console.log("Error from Submit Form:", e);
                    deferred.reject();
                });
            } else if (this.resp.status != Util.FORM_STATUS.SUBMITTED) {
                this.rootScope.mainShowLoader = false;
                toastr.success(Util.FORM_SUBMIT_MSGS.INCOMPLETE);
                deferred.resolve();
            }
        }, (e) => {
            this.rootScope.mainShowLoader = false;
            console.log(e);
            deferred.reject();
        });
        return deferred.promise;
    }

    submitEmbdForm(theForm): IPromise<any> {
        let deferred = this.$q.defer();
        let context = this;
        let modelCpy = _.cloneDeep(this.model);

        this.$validationProvider.validate(theForm)
            .success(() => {
                let resp = this.generateResponse(theForm, modelCpy);
                let formResponse = resp['formResponse'];
                let flds = angular.copy(formResponse.fields);

                this.FormService.validateUnAssignedForm(flds, this.formId).then(() => {
                    let formUuid = this.$_com.uuidv4();
                    this.FormService.uploadFrmDocs(formUuid, resp['formDocs'], resp['totalDocs']).then(() => {
                        this.rootScope.mainShowLoader = "Submitting Form...";
                        formResponse['key'] = window['apiKey'];
                        formResponse['uuid'] = formUuid;
                        this.ApiAdapterService.saveEmbdFormResponses(formResponse).then((res) => {
                            this.sbmtSuccess = true;
                            this.renderForm(this.formModel);
                            deferred.resolve(res);
                        }, () => {
                            this.sbmtSuccess = false;
                            this.$_snack.showErrorToastr({ message: Util.FORM_SUBMIT_ERROR });
                            deferred.reject();
                        }).finally(() => {
                            this.rootScope.mainShowLoader = false;
                        });
                    }, (err) => {
                        this.rootScope.mainShowLoader = false;
                        this.$_snack.showErrorToastr({ message: Util.FORM_SUBMIT_ERROR });
                        deferred.reject(err);
                    });
                }, (e) => {
                    if (typeof e == 'string') {
                        this.$_snack.showErrorToastr({ message: Util.FORM_SUBMIT_ERROR });
                    } else {
                        let err = Array.isArray(e) ? e : [e];
                        this.formUtils.parseBackendErrors(err, this.$scope);
                        this.$_snack.showErrorToastr({ message: Util.FORM_VALIDATION_ERROR });
                    }
                    deferred.reject();
                });
            })
            .error(function () {
                context.$_snack.showErrorToastr({ message: Util.FORM_VALIDATION_ERROR });
                deferred.reject();
            });
        return deferred.promise;
    }

    submitServiceNoteForm(noteId: number, serviceDate: any, serviceNoteForm: any): IPromise<any> {
        let deferred = this.$q.defer();
        let serviceDateTimestamp = Util.getUTCTime(new Date(serviceDate));
        if (serviceDateTimestamp > Util.getUTCTime(new Date())) {
            this.PopUpService.openInformationModal(Util.FUTURE_SERVICE_DATE_ERROR);
            this.$timeout(() => {
                deferred.resolve();
            }, 1000);
            return deferred.promise;
        }
        let payload;
        this.rootScope.mainShowLoader = true;
        this.$validationProvider.validate(serviceNoteForm).then(() => {
            this.saveForm(serviceNoteForm, true).then((s) => {
                payload = s;
                delete s.assignmentId;
                s.noteId = noteId;
                s.serviceDate = serviceDateTimestamp;
                let flds = angular.copy(s.fields);
                payload.password = this.CacheService.getPassword();
                this.FormService.validateUnAssignedForm(flds, this.formId).then(() => {
                    this.ApiAdapterService.createServiceNoteForm(this.service.assignedServiceId, payload).then(() => {
                        this.rootScope.mainShowLoader = false;
                        toastr.success(Util.NOTE_CREATED_SUCCESS);
                        this.noteSaveCallback();
                        deferred.resolve();
                    }, (e) => {
                        console.log("Error from Submit Form:", e);
                        this.rootScope.mainShowLoader = false;
                        if (e.errorCode == 'FORM_ALREADY_SUBMITTED') {
                            toastr.success(Util.FORM_ALREADY_SUBMITTED_ERROR);
                        } else if (e.errorCode == 'SUBMIT_FORM_INCOMPLETE') {
                            toastr.success(Util.NOTE_INCOMPLETE_STATUS);
                        }
                        deferred.reject();
                    });
                }, (e) => {
                    this.rootScope.mainShowLoader = false;
                    let err = Array.isArray(e) ? e : [e];
                    this.formUtils.parseBackendErrors(err, this.$scope);
                    this.signFlds.length > 0 && (this.formUtils.handleSignatureFlds());
                    toastr.success(Util.NOTE_INCOMPLETE_STATUS);
                    deferred.reject();
                });
            }, (e) => {
                if (e == "required") {
                    this.PopUpService.openInformationModal('Please fill all required fields.', null, null, null, true).then(
                        () => {
                            console.log("OK");
                        }
                    ).finally(() => {
                        deferred.reject();
                    });
                }
                console.log(e);
            });
        }, (e) => {
            console.log("Validation Error:", e);
            this.rootScope.mainShowLoader = false;
            toastr.success(Util.NOTE_VALIDATION_ERROR);
            this.$timeout(() => {
                deferred.resolve();
            }, 1000);
        });
        return deferred.promise;
    }

    updateServiceNoteForm(noteTypeId: number, serviceDate: any, serviceNoteForm: any, noteId?: number): IPromise<any> {
        let deferred = this.$q.defer();
        let serviceDateTimestamp = Util.getUTCTime(new Date(serviceDate));
        if (serviceDateTimestamp > Util.getUTCTime(new Date())) {
            this.PopUpService.openInformationModal(Util.FUTURE_SERVICE_DATE_ERROR);
            this.$timeout(() => {
                deferred.resolve();
            }, 1000);
            return deferred.promise;
        }
        this.rootScope.mainShowLoader = true;
        let payload;
        this.$validationProvider.validate(serviceNoteForm).then(() => {
            this.saveForm(serviceNoteForm, true).then((s) => {
                payload = s;
                delete s.assignmentId;
                s.noteId = noteId;
                s.serviceDate = serviceDateTimestamp;
                let flds = angular.copy(s.fields);
                payload.password = this.CacheService.getPassword();
                this.FormService.validateUnAssignedForm(flds, this.formId).then(() => {
                    this.FormService.updateServiceNote(noteId, noteTypeId, serviceDate, this.service.assignedServiceId, payload).then(() => {
                        toastr.success(Util.NOTE_UPDATED_SUCCESS);
                        this.noteSaveCallback(true);
                        deferred.resolve();
                    }, (e) => {
                        console.log("Error from Submit Form:", e);
                        if (!!e) {
                            let err = Array.isArray(e) ? e : [e];
                            this.formUtils.parseBackendErrors(err, this.$scope);
                            toastr.success(Util.NOTE_INCOMPLETE_STATUS);
                        }
                        deferred.reject();
                    }).finally(() => {
                        this.$rootScope.mainShowLoader = false;
                    });
                }, (e) => {
                    this.rootScope.mainShowLoader = false;
                    let err = Array.isArray(e) ? e : [e];
                    this.formUtils.parseBackendErrors(err, this.$scope);
                    this.signFlds.length > 0 && (this.formUtils.handleSignatureFlds());
                    toastr.success(Util.NOTE_INCOMPLETE_STATUS);
                    deferred.reject();
                });
            });
        }, (e) => {
            console.log("Validation Error:", e);
            this.rootScope.mainShowLoader = false;
            toastr.success(Util.NOTE_VALIDATION_ERROR);
            this.$timeout(() => {
                deferred.resolve();
            }, 1000);
        });
        return deferred.promise;
    }

    cancel(isFormBreadcrumb = false): void {
        // this.$scope.$$listeners.$stateChangeStart = [];
        this.deRegisterStateChange && this.deRegisterStateChange();
        let pg = '';
        if (this.ref == 'cmpf') {
            pg = 'completedForms';
        } else if (this.ref == 'asf' || this.ref == 'asfr') {
            pg = 'assignedForms';
        } else if (this.ref == 'avf' || this.ref == 'avfr' || this.ref == 'avfqa') {
            pg = 'availableForms';
        }

        if (this.ref == 'cmpfr') {
            this.FormService.viewForm(0, this.assignmentId, 'cmpf');
        } else if (this.ref == 'dshbd-cmpf' || this.ref == 'dshbd-asf') {
            if (!!isFormBreadcrumb) {
                this.FormService.manageForms(pg);
            } else {
                this.$state.go('parent-dashboard', { team: this.$state.params.subjectId });
            }
        } else {
            this.FormService.manageForms(pg);
        }
        this.rootScope.mainShowLoader = false;
        setTimeout(() => {
            window.removeEventListener("beforeunload", this.unloadFunction, true);
        }, 500);
    }

    cancelEmbdFrm = () => {
        this.sbmtSuccess = false;
        this.renderForm(this.formModel);
    }

    printForm = (): void => {
        window.print();
    }

    editForm = (): void => {
        this.FormService.fillForm(this.assignmentId, 'cmpfr');
    }

    isModelChanged = (): boolean => {
        let a = {};
        let b = {};
        let mdlBak = this.formUtils.modelBak;

        for (let i in this.model) {
            if (!!this.model[i]) {
                a[i] = this.model[i];
            }
        }

        for (let j in mdlBak) {
            if (!!mdlBak[j]) {
                b[j] = mdlBak[j];
            }
        }

        return !angular.equals(a, b);

    }

    // True while a form document upload is being sent to storage. Used by the
    // leave-page guards so the upload is not silently canceled on navigation.
    isUploadInProgress = (): boolean => {
        return !!this.FormService.formUploadInProgress();
    }

    setUnloadFunction(f: any): void {
        this.unloadFunction = f;
    }

    setDeRegisterStateChange(f: any) {
        this.deRegisterStateChange = f;
    }

    logout(): void {
        this.$rootScope.logout(true);
    }

    signForm = (form, theForm): IPromise<any> => {
        let deferred = this.$q.defer();
        this.$validationProvider.validate(form)
            .success(() => {
                this.saveForm(theForm, true, true).then(() => {
                    this.rootScope.mainShowLoader = true;
                    let password = this.CacheService.getPassword();
                    let consent = this.signature.consent ? 1 : 0;
                    this.ApiAdapterService.signAssignedForm(this.assignmentId, consent, this.signature.signedBy, password).then(
                        (s) => {
                            this.rootScope.mainShowLoader = false;
                            this.isSigned = true;
                            this.postSaveHandler(s.status);
                            toastr.success(Util.FORM_SIGNED_SUCCESS);
                            deferred.resolve();

                        },
                        (e) => {
                            console.log("Error from Sign Form:", e);
                            if (e.errorCode == 'FORM_ALREADY_SIGNED') {
                                toastr.success(Util.FORM_ALREADY_SIGNED_ERROR);
                            }
                            this.rootScope.mainShowLoader = false;
                            deferred.reject();
                        }
                    );
                }, (e) => {
                    console.log(e);
                    this.$timeout(() => {
                        deferred.reject();
                    }, 1000);
                });

            })
            .error((message: string) => {
                this.digitalSigned = false;
                console.log("Validation Error:", message);
                this.$timeout(() => {
                    deferred.reject();
                }, 1000);
            });
        return deferred.promise;
    }

    goToService = (assignedServiceId: number): void => {
        this.$_serviceManager.viewCurrentService(assignedServiceId,false);
    }

    triggerWorkflow = (action) => {
        let deferred = this.$q.defer();
        this.FormService.triggerWorkflow(this.resp, action).then(() => {
            this.cancel();
            deferred.resolve();
        }, () => {
            deferred.reject();
        });
        return deferred.promise;
    }
}

function form(): ng.IDirective {
    return {
        restrict: 'E',
        templateUrl: function (element, attrs) {
            let url;
            if (!!attrs.service) {
                url = 'app/common/formTemplate/components/templates/service-note-form.directive.html';
            } else if (!!attrs.embeddedForm) {
                url = 'app/common/formTemplate/components/templates/embedded-form.directive.html';
            } else {
                url = 'app/common/formTemplate/components/templates/form.directive.html';
            }
            return url;
        },
        replace: true,
        controller: EcvForm,
        controllerAs: 'formVm',
        scope: true,
        bindToController: {
            'formId': '=?',
            'ref': '=?',
            'assignmentId': '=?asgnId',
            'formData': '=?',
            'viewOnly': '=?',
            'isEditAction': '=?',
            'onLoadCallback': '=',
            'service': '=?',
            'noteSaveCallback': '=?',
            'selectedSubject': '=?',
            'embeddedForm': '@',
            "selectedSubjectid": "="
        },
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: IEcvForm): void => {
            controller.init();

            function unloadFunction(e) {
                if (!!controller.isModelChanged()) {
                    let confirmationMessage = "\o/";
                    e.returnValue = confirmationMessage;
                    return confirmationMessage;
                }
            }

            controller.setUnloadFunction(unloadFunction);
            window.addEventListener("beforeunload", unloadFunction, true);


            let removeMe = true;

            let stateChangeEvent = function (event) {
                removeMe = true;
                if ((typeof controller.resp.dateSubmitted == 'undefined' || !controller.viewOnly) && !!controller.isModelChanged() || !!controller.isUploadInProgress()) {
                    let confirmationMessage = Util.FORM_CHANGES_NOT_SAVED;
                    let answer = confirm(confirmationMessage);
                    if (!answer) {
                        event.preventDefault();
                        controller.rootScope.mainShowLoader = false;
                        removeMe = false;
                        controller.rootScope.latestSelectedSubject = null;
                    } else {
                        setTimeout(() => {
                            window.removeEventListener("beforeunload", unloadFunction, true);
                        }, 500);
                        controller.rootScope.activeResourceSubjectId = null;
                        controller.rootScope.selectChild(controller.rootScope.latestSelectedSubject || -1);
                        controller.rootScope.latestSelectedSubject = null;
                    }
                }
                if (!!removeMe) {
                    deRegisterStateChange();
                    window.removeEventListener("beforeunload", unloadFunction, true);
                } else {
                    deRegisterStateChange();
                    setTimeout(() => {
                        deRegisterStateChange = scope.$on('$stateChangeStart', stateChangeEvent);
                    }, 500);
                }
            }

            let deRegisterStateChange = scope.$on('$stateChangeStart', stateChangeEvent);

            controller.setDeRegisterStateChange(deRegisterStateChange);

            scope.$on('handleFormStateChange', (event) => {
                if (!!controller.isModelChanged()) {
                    let cm = Util.FORM_CHANGES_NOT_SAVED;
                    let ans = confirm(cm);
                    if (!ans) {
                        //do nothing
                    } else {
                        deRegisterStateChange();
                        controller.logout();
                    }
                } else {
                    controller.logout();
                }
            });

            // uncomment to print model value in console for debugging purpose.
            // scope.$watch(() => {
            //     return !!controller.model ? controller.model : null;
            // }, (newVal, oldVal) => {
            //     if (newVal != oldVal) {
            //         console.dir(controller.model);
            //     }
            // }, true);

        }
    }
}

angular.module('eCareVault.common.formTemplate').directive('ecvForm', form);

